export let StatusEvent = [
  {
    key: "REQUESTED",
    name: "SOLICITADO",
  },
  {
    key: "CANCELED",
    name: "CANCELADO",
  },
  {
    key: "SCHEDULE",
    name: "AGENDADO",
  },
  {
    key: "FINISHED",
    name: "FINALIZADO",
  },
];

export function convertStatus(statusEvent) {
  const value = StatusEvent.find((type) => type.key == statusEvent);
  return value.name;
}
